import { useState } from "react";
import { getTenantSlug } from "@/helpers/tenant";
import { loadingImageUrl } from "@/helpers/storage";

// Ortak yükleme animasyonu (assets/css/loading.css). Menu ve BranchPicker paylaşır.
// Partner görseli varsa dalgaların üstünde gösterilir; yoksa (404) sadece dalgalar kalır.
export default function LoadingWaves() {
  const [showImage, setShowImage] = useState(true);
  const imageUrl = loadingImageUrl(getTenantSlug());

  return (
    <div
      className="loading-container"
      role="status"
      aria-live="polite"
      aria-label="Menü yükleniyor"
    >
      {imageUrl && showImage && (
        <img
          className="logo"
          src={imageUrl}
          alt=""
          width={80}
          height={80}
          onError={() => setShowImage(false)}
        />
      )}
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
    </div>
  );
}
